import React from 'react';
import ChipEdit from 'ChipEdit';
import transform from '../../../common/transform';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from './header/';
import Content from './content/';
import BottomFooter from './bottomFooter';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { content } = this.props;
        const {
            docData,
            docData: {
                noAd,
                base62Id,
                searchPath,
                title,
                pcUrl,
                url,
                newsTime,
                updateTime,
                fhhAccountDetail,
                source,
                sourceUrl,
                skey,
                commentUrl,
                subscribe,
            },
            logo,
            search,
            recommend,
            subject,
            recommendInfo,
            topAd,
            bottomAd,
            footer,
            hasCopyRight,
            sourceReason,
        } = content;

        const headerData = {
            logo,
            search,
            topAd,
        };
        const contentData = {
            captionData: {
                noAd,
                base62Id,
                fhhAccountDetail,
                title,
                pcUrl,
                url,
                newsTime,
                updateTime,
                source,
                sourceUrl,
                skey,
                commentUrl,
                subscribe,
            },
            leftContentData: {
                article: docData,
                recommendInfo,
                hasCopyRight,
                sourceReason,
            },
            rightContentData: {
                searchPath,
                recommend,
                subject,
            },
        };
        const footerData = { bottomAd, footer };

        return (
            <div>
                <Header content={headerData} />
                <Content content={contentData} />
                <BottomFooter content={footerData} />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
